<ui-notification [uuid]="uuid()" [duration]="duration()" color="error">
  <ng-icon name="heroXCircle" size="24" class="!block size-6" slot="icon" />
  <p class="text-sm font-medium text-on-surface dark:text-on-surface-darkmode">
    {{ 'errors.chunkLoadError.title' | transloco }}
  </p>
  <p class="mt-1 text-sm text-on-surface-subtle dark:text-on-surface-subtle-darkmode">
    {{ 'errors.chunkLoadError.subtitle' | transloco }}
  </p>
  <div class="mt-3 flex gap-1">
    <ui-button size="small" mode="outlined" (click)="onClickReload()">
      <ng-icon name="heroArrowPath" size="20" slot="start" class="!block" />
      <span class="overflow-hidden text-ellipsis whitespace-nowrap">
        {{ 'errors.chunkLoadError.reloadButton' | transloco }}
      </span>
    </ui-button>
  </div>
</ui-notification>
